import {
  GETMANUALOTPLIST_SUCCESS,
  GETMANUALOTPLIST_FAILED,
  RESET_GETMANUALOTPLIST,
  LOADING_GETMANUALOTPLIST,
  NETWORK_ERROR_GETMANUALOTPLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetManualOtpList = () => {
  return { type: RESET_GETMANUALOTPLIST };
};

const getManualOtpList = (userData, authTokenIs) => async (dispatch) => {
  dispatch({ type: LOADING_GETMANUALOTPLIST });
  await partnerServices
    .post("getManualOtpList", userData, { headers: { AuthToken: authTokenIs } })
    .then((res) => {
      switch (res.status) {
        case 200:
          dispatch(getManualOtpListsuccess(res.data));
          break;
        default:
          dispatch(getManualOtpListFailed(res.data));
          break;
      }
    })
    .catch((err) => {
      dispatch({ type: NETWORK_ERROR_GETMANUALOTPLIST, payload: err });
    });
};
function getManualOtpListsuccess(data) {
  return {
    type: GETMANUALOTPLIST_SUCCESS,
    payload: data,
  };
}
function getManualOtpListFailed(data) {
  return {
    type: GETMANUALOTPLIST_FAILED,
    payload: data,
  };
}

export { resetGetManualOtpList, getManualOtpList };
